import React from 'react';
import {FormattedMessage} from 'react-intl';
import * as _ from 'lodash';
import moment from 'moment/moment';

export function CardEditSendColumnFormatter(row) {
  const createdAt = _.get(row, 'createdAt', '')
    ? moment(_.get(row, 'createdAt', '')).format('DD-MM-YYYY HH:mm') : '';
  const agentID = _.get(row, 'agentID', '');
  const agentName = _.get(row, 'agentName', '');
  const customerName = _.get(row, 'customerName', '');
  const phone = _.get(row, 'phone', '');
  const total = _.get(row, 'total', '');
  const prefix = 'invoice-orders-column';
  const containerClassnames = 'd-flex align-items-center border';
  const labelClassnames = 'custom-brand-color font-weight-bolder bg-secondary py-2 px-1 w-75px';
  const fontStyles = {fontSize: 11};
  const itemClassnames = 'text-dark-75 font-weight-bold px-1';

  return (
    <div>
      <div className={containerClassnames}>
        <span className={labelClassnames} style={fontStyles}>
          <FormattedMessage id={`${prefix}-createdAt`} defaultMessage={'Created at'}/>:
        </span>
        <div className={itemClassnames} style={fontStyles}>{createdAt}</div>
      </div>
      <div className={containerClassnames}>
        <span className={labelClassnames} style={fontStyles}>
          <FormattedMessage id={`${prefix}-agent`} defaultMessage={'Agent'}/>:
        </span>
        <div>
          <div className={itemClassnames} style={fontStyles}>{agentID}</div>
          <div className={itemClassnames} style={fontStyles}>{agentName}</div>
        </div>
      </div>
      <div className={containerClassnames}>
        <span className={labelClassnames} style={fontStyles}>
          <FormattedMessage id={`${prefix}-customerName`} defaultMessage={'Customer name'}/>:
        </span>
        <div className={itemClassnames} style={fontStyles}>{customerName}</div>
      </div>
      <div className={containerClassnames}>
        <span className={labelClassnames} style={fontStyles}>
          <FormattedMessage id={`${prefix}-phone`} defaultMessage={'Phone'}/>:
        </span>
        <div className={itemClassnames} style={fontStyles}>{phone}</div>
      </div>
      <div className={containerClassnames}>
        <span className={labelClassnames} style={fontStyles}>
          <FormattedMessage id={`${prefix}-totalAmount`} defaultMessage={'Amount'}/>:
        </span>
        <div className={itemClassnames} style={fontStyles}>{total}</div>
      </div>
    </div>
  );
}
